import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import usePDFPrintHook from "../../customHooks/usePDFPrintHook";
import print from "print-js";
import useDeleteHook from "../../customHooks/useDeleteHook";
import { toast } from "react-toastify";

const EditManifestComponent = loadable(
  () => import("../../components/Manifest/EditManifest")
);
const EditManifest = () => {
  const { id } = useParams()
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`manifest-${id}`],
    url: `${APIS.MANIFEST}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`manifest-${id}`, "manifest"],
    navigateURL: "",
  });

  const { mutateAsync: deleteMutateAsync, isLoading: isDeleteLoading } = useDeleteHook({
    queryKey: [`manifest-${id}`, "manifest"],
  });

  console.log("test", data)

  const handleDeleteManifestItem = async (pk: string) => {
    if (!data.is_active) {
      toast.error("You cannot delete manifest item, when mark as done")
      return
    }
    const url = `${APIS.MANIFEST_ITEMS}${pk}/`
    try {
      const res = await deleteMutateAsync({ url })
      console.log(res, "ii")
    } catch (err) {
      console.log(err);
    }
  }

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } = usePatchHook({
    queryKey: [`manifest-${id}`, "manifest"],
    navigateURL: "",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      is_active: false,
    };
    try {
      await toggleMarkAsDone({ url, formData, setError });
      await refetch()
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["manifest-items"],
    navigateURL: "",
  });

  const handleAttachConsignment = async (consignmentId: string) => {
    const url = `${APIS.MANIFEST_ITEMS}`;
    let formData = {
      manifest: id,
      order: consignmentId
    };
    try {
      await attachConsignmentMutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }

  const { mutateAsync: downloadManifest, isPostLoading: isPrintLoading } = usePDFPrintHook({
    queryKey: [],
  });

  const handlePrint = async () => {
    const url = `${APIS.MANIFEST}${id}/print-pdf-manifest/`;
    let formData = {
    };
    try {
      const res = await downloadManifest({ url, formData });
      const fileURL = URL.createObjectURL(res?.data);
      print(fileURL);
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Manifest</span>
      </div>
      {isLoading ? <Spinner /> : <EditManifestComponent
        isLoading={isPatchLoading}
        data={{ ...data }}
        handleEdit={handleEdit}
        handleAttachConsignment={handleAttachConsignment}
        handleToggleMarkAsDone={handleToggleMarkAsDone}
        handlePrint={handlePrint}
        isPrintLoading={isPrintLoading}
        handleDeleteManifestItem={handleDeleteManifestItem}
      />}
    </>
  );
};
export default EditManifest;
